import { SET_PERFORMANCE_ASSESSMENT_NAME as type } from '.';

export default payload => ({
  type,
  payload,
});
